import { useQuery } from '@tanstack/react-query';
import {
  getFreelancerInvoices,
  getFreelancerInvoiceDetail,
} from '../services/api/freelancerInvoices';

export function useFreelancerInvoices(year: number, month: number) {
  return useQuery({
    queryKey: ['freelancerInvoices', year, month],
    queryFn: () => getFreelancerInvoices(year, month),
    enabled: !!year && !!month,
  });
}

export function useFreelancerInvoiceDetail(userId: number, year: number, month: number) {
  return useQuery({
    queryKey: ['freelancerInvoiceDetail', userId, year, month],
    queryFn: () => getFreelancerInvoiceDetail(userId, year, month),
    enabled: !!userId && !!year && !!month,
  });
}
